function n(e) {
  return function(r) {
    return r == null ? void 0 : r[e];
  };
}
var t = n;
export {
  t as default
};
//# sourceMappingURL=_baseProperty.js.map
